import React, { useMemo } from 'react';
import { useGetReconCommentsQuery } from '../services/commentsApiSlice';

import type { ColDef } from 'ag-grid-enterprise';
import { AgGridReact } from 'ag-grid-react';

interface Props {
  breakId: string;
}

interface IRow {
  commentDate: string;
  commentBy: number;
  comment: boolean;
}

const CommentsComponent: React.FC<Props> = ({ breakId }) => {
  const { data, error, isLoading } = useGetReconCommentsQuery(breakId, {
    refetchOnMountOrArgChange: true,
  });

  const colDefs: ColDef<IRow>[] = useMemo(
    () => [
      { field: 'commentDate' },
      { field: 'commentBy' },
      {
        field: 'comment',
        resizable: false,
        flex: 1,
        wrapText: true,
        autoHeight: true,
        cellStyle: { lineHeight: '23px', padding: '10px' },
      },
    ],
    []
  );

  const defaultColDef = useMemo<ColDef>(
    () => ({
      initialWidth: 200,
      sortable: true,
      resizable: true,
    }),
    []
  );

  if (isLoading) return <p>Loading comments...</p>;

  if (error) return <p>Error loading comments.</p>;

  if (!data) {
    return <div className="text-xl">No comments</div>;
  }
  const paginationPageSizeSelector = [5, 10, 20];

  return (
    <div style={{ width: '100%' }}>
      <AgGridReact
        rowData={data}
        columnDefs={colDefs}
        defaultColDef={defaultColDef}
        pagination={data.length > 5}
        paginationPageSizeSelector={paginationPageSizeSelector}
        paginationPageSize={5}
        domLayout="autoHeight"
      />
    </div>
  );
};

export default CommentsComponent;
